import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSurgeons } from '@utilities/hooks/useSurgeons/useSurgeons';
import { ROUTE_CONSTANTS } from '@utilities/RouteConstants';
import { DEFAULT_SELECTION_ALL } from '@utilities/constants';
import {
	useBlockReleaseRequestContext
} from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestContext/BlockReleaseRequestContext';
import { useRouteParams } from '@components/BlockRelease/utils/hooks/useRouteParams/useRouteParams';

export const useSingleSurgeonSelection = () => {
	const history = useHistory();

	const { surgeonByNpi } = useSurgeons();
	const { surgeonNpi } = useRouteParams();
	const prevSelectedSurgeonNpi = React.useRef<string | undefined>(surgeonNpi);
	const { releases, selectedSurgeonFilter, setSelectedSurgeonFilter } = useBlockReleaseRequestContext();

	React.useEffect(() => {
		if (prevSelectedSurgeonNpi.current !== DEFAULT_SELECTION_ALL) {
			prevSelectedSurgeonNpi.current = surgeonNpi;
			setSelectedSurgeonFilter(surgeonNpi);
		}
	}, [selectedSurgeonFilter, setSelectedSurgeonFilter, surgeonNpi]);

	const filteredSurgeonList = React.useMemo(() => {
		const npiList = Array.from(new Set(releases?.flatMap((release) => release.npis)));
		return npiList.map((npi) => surgeonByNpi[npi]).filter((Boolean));
	}, [releases, surgeonByNpi]);

	const handleUpdateUrlAndSetFilter = React.useCallback((selected: string) => {
		const queryParams = new URLSearchParams({ surgeon: selected }).toString();
		history.replace(`${ROUTE_CONSTANTS.BLOCK_RELEASE_RECOMMENDATION_LIST}?${queryParams}`);
		setSelectedSurgeonFilter(selected);
	}, [history, setSelectedSurgeonFilter]);

	return {
		filteredSurgeonList,
		selectedSurgeonFilter,
		setSelectedSurgeonFilter: handleUpdateUrlAndSetFilter,
	};
};
